import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { authThunks } from "@app/redux/thunks/auth.thunk";

import { LoginModal } from "./login-modal/login-modal";

const AuthProvider = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authThunks.authenticate());
  }, []);

  return <LoginModal />;
};

export { AuthProvider };
